<template>
    <div :class="`comment_box w-full comment_box_${ commentKey }`">
        <div class="mb-4 lg:mb-6" v-if="commentsList && commentsList.length">
            <div class="mb-4 lg:mb-6" v-for="item in commentsList" :key="`comment_${ item.uid }`">
                <CommentItem
                    :onDelete="onDelete"
                    :tree="tree"
                    :clubCommentDelete="clubCommentDelete"
                    :treeHideButton="treeHideButton"
                    :commentsLength="commentsList.length"
                    :answerTo="answerTo"
                    :previewSize="previewSize"
                    :item="item"
                    :mode="mode"
                    :answerOn="answerOn"
                    :commentKey="commentKey"
                    :previewMode="previewMode" 
                    
                    v-on:showAnserInput="toggleShowInput($event)"
                    />
            </div>
            <div v-if="showNextComments" @click="nextHandler(commentKey)" class="cursor-pointer text-primary flex items-center">
                <span class="next_show_btn">{{$t('following_comments')}}</span>
                <feather-icon class="ml-2" icon="ChevronDownIcon" svg-classes="h-4 w-4" />
            </div>
        </div>
        <div class="mb-4 lg:mb-6" v-else>
            {{$t('no_comments')}}
        </div>

        <CommentInput v-if="!isShowInput" :mode="mode" :commentKey="commentKey"  />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import commentModule from '@/store/modules/comments'

import CommentInput from './CommentInput'
import CommentItem from './CommentItem'

export default {
    props: {
        commentKey: { // UID или Ключ куда будут привязыватьс комменты, обязательный ключ
            type: String,
            required: true
        },
        mode: { // Режим комментариев, если big то форма комментов большая, если smile то маленькая
            type: String,
            default: 'big'
        },
        previewMode: { // Режим комментариев, если false то изначально подгружаються 10 комментариев, если true изначально подружаеться 1 комментарий с кнопкой показать еще, для ленты новостей лучше юзать true. для полной новости false
            type: Boolean,
            default: false
        },
        previewSize: { // Если включен previewMode то тут указываем количество комментарив которые видны изначально
            type: Number,
            default: 2
        },
        treeHideButton: { // Скрыть(false)/Показать(true) кнопку скрытия ответов
            type: Boolean,
            default: true
        },
        tree: { // Режим комментариев, если true то вывод будет деревом, если false то списком
            type: Boolean,
            default: true
        },
        onDelete: { // Если true то пользователям можно удалять комменты, если false то нельзя
            type: Boolean,
            default: true
        },
        answerTo: { // Показывать или скрывать рядом с именем пользователя комментария кому был этот ответ
            type: Boolean,
            default: true
        },
        answerOn: { // Если true ответы включены, если false отвечать на комментарии нельзя
            type: Boolean,
            default: true
        },
        clubCommentDelete: { // ДЛя удаления комментаринв основателю в студ клубе 
            type: Boolean,
            default: false
        }
    },
    components: {
        CommentItem,
        CommentInput
    },
    data() {
        return {
            page_size: this.previewMode ? this.previewSize : 10,
            page: this.previewMode ? 0 : 1,
            isShowInput:false,
        }
    },
    created: function() {
        // Если модуль не зарегистирован, регистрируем его
        if(!this.$store.hasModule('comment'))
            this.$store.registerModule('comment', commentModule)

        // Запрашиваем комменты
        this.getHandler(this.commentKey)
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            comments: state => state.comment.comments,
            count: state => state.comment.commentsCount
        }),
        commentsList() {
            // Получаем список комментов по ключу
            if(Object.keys(this.comments).length && this.comments[this.commentKey])
                return this.comments[this.commentKey]
        },
        commentsCount() {
            // Получаем общее количество комментов по ключу
            if(Object.keys(this.count).length && this.count[this.commentKey])
                return this.count[this.commentKey]
        },
        showNextComments() {
            // Показываем кнопку загрузить еще
            if(this.commentsList.length < this.commentsCount)
                return true
        }
    },
    methods: {
        ...mapActions({
            getComment: 'comment/getComment'
        }),
        async nextHandler(uid) {
            // Формируем данные для получения следующей страницы
            if(this.previewMode) {
                this.page_size = 10
            }
            this.page = this.page+1
            await this.getHandler(uid, 'push', this.page)
        },
        async getHandler(uid, type = 'set', page = 1) {
            // Запрашиваем страницу
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: `.comment_box_${ this.commentKey }`,
                        scale: 0.6
                    })
                })
                await this.getComment({uid, page, type, page_size: this.page_size, previewMode: this.previewMode, previewSize: this.previewSize})
            } catch(e) {

            } finally {
                this.$vs.loading.close(`.comment_box_${ this.commentKey } > .con-vs-loading`)
            }
        },
        toggleShowInput(event){
            this.isShowInput = event;
        }
    }
}
</script>

<style lang="scss">
.comment_box{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>

<style lang="scss" scoped>
.next_show_btn{
    border-bottom: 1px solid;
}
</style>
